import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { AccountService } from 'src/app/core/service/account.service';
import { map, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private accountService: AccountService
  ) { }
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      if (!this.authService.isLoggedIn) {
        console.log("Auth Guard Force Login");
        const redirectUrl = window.location.pathname;
        this.router.navigate(['/login'], { queryParams: { 'redirectURL': redirectUrl } });
        return false;
      }

      // Check if trying to access rewards dashboard and if rewards are hidden
      if (state.url.includes('/dashboard/rewards')) {
        return this.accountService.hideRewards$.pipe(
          take(1),
          map(hideRewards => {
            if (hideRewards) {
              // console.log("Rewards access denied - feature disabled");
              this.router.navigate(['/dashboard']);
              return false;
            }
            return true;
          })
        );
      }

      return true;
    }
}
